import { Invoice, PaymentMethod } from "@/shared/domains";
import { parseResponseData, privateAPI } from "@/shared/lib";

export const getPaymentHistory = async () => {
  const response = await privateAPI.get(`/patients/payment-information`);

  return parseResponseData(response, Invoice.array());
};

export const getPaymentMethod = async () => {
  const response = await privateAPI.get(`/patients/payment-method`);

  return parseResponseData(response, PaymentMethod.nullable());
};

export const updatePaymentMethod = async (
  paymentMethodId: PaymentMethod["id"],
) => {
  return await privateAPI.put(`/patients/payment-method`, { paymentMethodId });
};
